// Styles for ConsentCheckListItem go here.
import { toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledConsentCheckListItem = styled.div`
  background-color: white;
  display: flex;
  width: 60%;
  align-items: center;
  .m-checkbox-class {
    width: 90%;
    margin-right: ${toRem(32)};
  }
  .m-checkbox-label {
    .legal-text-link {
      margin: ${toRem(8)} 0;
    }
  }
  .m-checkbox-error {
    .legal-text-link {
      margin: ${toRem(8)} 0 0;
      color: red;
    }
  }
`;
